import { useTranslation } from 'react-i18next';

interface UseFreeProductCheckoutModalTranslationsArgs {
  isLoggedIn: boolean;
  productCtaText?: string | null;
}

const useFreeProductCheckoutModalTranslations = ({
  isLoggedIn,
  productCtaText,
}: UseFreeProductCheckoutModalTranslationsArgs) => {
  const { t } = useTranslation();

  const defaultSubmitText = isLoggedIn ? t('shared.cta.submit') : t('products.free_product_guest_checkout.submit');

  return {
    'products.free_product_checkout.title': isLoggedIn
      ? t('products.free_product_logged_in_checkout.title')
      : t('products.free_product_guest_checkout.title'),
    'products.free_product_checkout.description': isLoggedIn
      ? t('products.free_product_logged_in_checkout.description')
      : t('products.free_product_guest_checkout.description'),
    'products.free_product_checkout.email_label': t('products.free_product_guest_checkout.email_label'),
    'products.free_product_checkout.email_placeholder': t('products.free_product_guest_checkout.email_placeholder'),
    'products.free_product_checkout.submitting': isLoggedIn
      ? t('shared.actions.submitting')
      : t('products.free_product_guest_checkout.submitting'),
    'products.free_product_checkout.submit': productCtaText?.trim() || defaultSubmitText,
  };
};

export default useFreeProductCheckoutModalTranslations;
